import React, { SyntheticEvent, CSSProperties } from 'react';
import classnames from 'classnames';

import { isExist } from 'util/helper';

import styles from './index.css';

export type IconSize = 'normal' | 'small' | 'large' | 'x-small' | 'inherit';

interface IconProperty {
	className?: string;
	badgeClassName?: string;
	src: string;
	size?: IconSize;
	style?: CSSProperties;
	badge?: string;
	onClick?: (event: SyntheticEvent) => void;
	onMouseEnter?: (event: SyntheticEvent) => void;
	onMouseLeave?: (event: SyntheticEvent) => void;
}

const Icon: React.FC<IconProperty> = ({
	className,
	badgeClassName,
	src: Svg,
	size = 'normal',
	badge,
	style,
	onClick,
	onMouseEnter = () => {},
	onMouseLeave = () => {},
}) => (
	<div
		className={classnames(styles.icon, className, isExist(size) && styles[size], {
			[styles.clickable]: isExist(onClick),
		})}
		style={style}
		role="button"
		tabIndex={0}
		onClick={onClick}
		onKeyPress={() => {}}
		onMouseEnter={onMouseEnter}
		onMouseLeave={onMouseLeave}
	>
		{badge && <div className={classnames(styles.badge, badgeClassName)}>{badge}</div>}
		{typeof Svg === 'string' && Svg.startsWith('http') ? (
			<img src={Svg} alt="customUrl" />
		) : (
			<Svg />
		)}
	</div>
);

export default Icon;
